import { useEffect, useState } from "react";

/** CSS 미디어쿼리 매칭 여부. SSR/테스트 환경(matchMedia 없음)에서는 false. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => globalThis.matchMedia?.(query).matches ?? false);
  useEffect(() => {
    const mq = globalThis.matchMedia?.(query);
    if (!mq) return;
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

/** 폰 브레이크포인트 — globals.css 의 `@media (max-width: 739px)` 와 같은 값.
 *  iPad mini 세로(744px)는 태블릿으로 취급해야 하므로 759 가 아닌 739. */
export const PHONE_QUERY = "(max-width: 739px)";
